import React from "react";
import { Switch, Route, NavLink } from "react-router-dom";
import DeleteApprovedOrder from "./../DeleteApprovedOrder/DeleteApprovedOrder";
import "./Orders.css";
import Approved from "./Approved/Approved";
import Pending from "./Pending/Pending";
import DeleteOrder from "../DeleteOrder/DeleteOrder";
import ApproveOrder from "../ApproveOrder/ApproveOrder";

const Orders = ({ props, user }) => {
  return (
    <div>
      <div className="orders__collection">
        <div className="orders__nav">
          <NavLink
            to="/dashborad/orders/pending"
            className="orders__link link m-r-s"
          >
            Pending
          </NavLink>
          <NavLink
            to="/dashborad/orders/approved"
            className="orders__link link"
          >
            Approved
          </NavLink>
        </div>

        <div className="dashborad__content">
          <Switch>
            <Route path={`${props.match.path}/`} exact component={Pending} />
            <Route
              path={`${props.match.path}/approved`}
              exact
              component={() => <Approved user={user} />}
            />
            <Route
              path={`${props.match.path}/pending`}
              exact
              component={Pending}
            />

            <Route
              path="/dashborad/orders/delete/:id"
              exact
              component={(props) => <DeleteOrder props={props} />}
            />

            <Route
              path="/dashborad/orders/approve/:id"
              exact
              component={(props) => <ApproveOrder props={props} />}
            />

            <Route
              path="/dashborad/orders/approved/delete/:id"
              exact
              component={(props) => <DeleteApprovedOrder props={props} />}
            />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Orders;
